import { render, staticRenderFns } from "./New-War.vue?vue&type=template&id=68675dc7"
import script from "./New-War.vue?vue&type=script&lang=js"
export * from "./New-War.vue?vue&type=script&lang=js"
import style0 from "./New-War.vue?vue&type=style&index=0&id=68675dc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports